import { render, staticRenderFns } from "./ClosingTimes.vue?vue&type=template&id=2249248e&scoped=true&"
import script from "./ClosingTimes.vue?vue&type=script&lang=js&"
export * from "./ClosingTimes.vue?vue&type=script&lang=js&"
import style0 from "./ClosingTimes.vue?vue&type=style&index=0&id=2249248e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2249248e",
  null
  
)

export default component.exports